import { render } from "./DepartmentStore.vue?vue&type=template&id=048d266d&scoped=true"
import script from "./DepartmentStore.vue?vue&type=script&lang=js"
export * from "./DepartmentStore.vue?vue&type=script&lang=js"

import "./DepartmentStore.vue?vue&type=style&index=0&id=048d266d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048d266d"]])

export default __exports__